export default "__VITE_ASSET__7b917502__"